(function () {
  var cartId = 'rebuy-cart';
  var observedCart = null;
  var cartObserver = null;
  var syncing = false;

  function getCart() {
    return document.getElementById(cartId);
  }

  function isCartVisible(cart) {
    return cart.classList.contains('is-visible');
  }

  function syncAriaHidden(cart) {
    if (!cart || syncing) return;

    var shouldHide = !isCartVisible(cart);
    var current = cart.getAttribute('aria-hidden');
    var expected = shouldHide ? 'true' : 'false';

    if (current === expected) return;

    syncing = true;
    cart.setAttribute('aria-hidden', expected);
    syncing = false;
  }

  function observeCart(cart) {
    if (!cart || observedCart === cart) {
      if (cart) syncAriaHidden(cart);
      return;
    }

    if (cartObserver) {
      cartObserver.disconnect();
      cartObserver = null;
    }

    observedCart = cart;
    syncAriaHidden(cart);

    cartObserver = new MutationObserver(function () {
      syncAriaHidden(cart);
    });

    cartObserver.observe(cart, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'class']
    });
  }

  function ensureCartObserved() {
    observeCart(getCart());
  }

  function init() {
    ensureCartObserved();

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        for (var j = 0; j < mutation.addedNodes.length; j++) {
          var node = mutation.addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.id === cartId || (node.querySelector && node.querySelector('#' + cartId))) {
            ensureCartObserved();
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
